import Swiper from 'swiper/bundle';
import {each} from 'lodash';
import ScrollManager from '../_managers/scroll';
import {x, x0, isTouch} from '../_helpers';

export default class MapBlock {

    constructor() {
        this.el = x0('.m-map');
        if(!this.el) return;
        this.points = x('.m-map__point');
        this.cZindex = 1;
        this.init();
    }

    update() {
        this.mobileCarousel.update();
    }

    setActivePoint(swiper) {
        each(this.points, (p,j) =>{
            const dot = x0('.m-map__dot',p);
            if(j === swiper.activeIndex) {
                dot.classList.add('-active')
                p.style.zIndex = ++this.cZindex;
            } else {
                dot.classList.remove('-active')
            }
        });
    }

    onPointClick(k,e) {
        e.target.style.zIndex = ++this.cZindex;
        this.mobileCarousel.slideTo(k);
        each(this.points, (p,j) => {
            const dot = x0('.m-map__dot',p);
            if(k===j) {
                dot.classList.add('-active');    
            } else {
                dot.classList.remove('-active');
            }
        })
    }

    init() {
        this.mobileCarousel = new Swiper(x0('.m-map__mobile', this.el), {
            spaceBetween: 20,
            slideToClickedSlide: true,
            on: {
                touchStart: ScrollManager.stop,
                touchEnd: ScrollManager.start,
                init: !!isTouch && this.setActivePoint.bind(this),
                slideChange: this.setActivePoint.bind(this)
            }
        });   

        each(this.points, (p,k) => {
            !isTouch && p.addEventListener('mouseenter', this.onPointClick.bind(this,k));
            p.addEventListener('click', this.onPointClick.bind(this,k));
        });    
    }
}